<div *ngIf="translationForm" [formGroup]="translationForm">
    <ng-container *ngIf="!previewTranslationEnabled; else translationPreviewTemp">
        <mat-accordion multi>
            <ng-container *ngFor="let lang of orgLanguages; trackBy: trackByFn">
                <mat-expansion-panel
                    [formGroupName]="lang"
                    (opened)="changeToggleFor(lang, false)"
                    (closed)="changeToggleFor(lang, true)"
                    [expanded]="!translationFormControl[lang]?.get('autoTranslate')?.value"
                    hideToggle
                    [class.mat-elevation-z0]="isChild"
                    [disabled]="disabled"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-subtitle-2"> {{ lang }} </mat-panel-title>
                        <mat-slide-toggle
                            [id]="lang"
                            color="accent" 
                            class="opacity-full" 
                            [checked]="translationFormControl[lang]?.get('autoTranslate')?.value"
                            [disabled]="true"
                        >
                        </mat-slide-toggle>
                    </mat-expansion-panel-header>
                    <mat-form-field class="example-full-width row-4 relative" appearance="outline" [style.fontSize.px]="14">
                        <mat-label>Enter your text here</mat-label>
                        <textarea matInput maxlength="750" placeholder="Enter your text here" formControlName="message"></textarea>
                        <div
                            class="d-flex justify-content-end position-count mat-small grey"
                            [ngClass]="{ 'warn-text': translationFormControl[lang]?.get('message')?.value?.length >= 750 }"
                        >
                            {{ translationFormControl[lang]?.get('message')?.value?.length }}/750
                        </div>
                    </mat-form-field>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </ng-container>

    <ng-template #translationPreviewTemp>
        <div class="translation-preview-container">
            <ng-container *ngFor="let lang of orgLanguages; trackBy: trackByFn">
                <div
                    [formGroupName]="lang"
                    class="translation-preview-lang"
                    [class.expanded]="!translationFormControl[lang]?.get('autoTranslate')?.value || (previewTranslationData && lang == previewTranslationData.previewLanguage)"
                    [class.mat-elevation-z0]="isChild"
                >
                    <div class="syncing-overlay" *ngIf="isAnalyzerLoading">
                        <span class="skeleton-pulse syncing-text">Syncing...</span>
                    </div>
                    <div class="translation-preview-lang-header d-flex justify-content-between align-items-center">
                        <mat-panel-title class="mat-subtitle-2 d-flex align-items-center"> 
                            {{ lang }} 
                            <div *ngIf="isAnalyzerLoading" class="skeleton-pulse ml-8 skeleton-loader-text"></div>
                            <ng-container *ngIf="!isAnalyzerLoading && getLanguageAnalyzerData(lang) as langData">
                                <div class="ml-8"
                                     [ngClass]="!isAnalyzerLoading && (langData.segmentCount ?? 0) > TRANSLATION_SEGMENT_THRESHOLD ? 'segment-count-box-warn' : 'mat-small grey'">
                                    {{ langData.segmentCount }} segments
                                </div>
                            </ng-container>
                        </mat-panel-title>
                        <div class="d-flex flex-row align-items-center">
                            
                            <ng-container *ngIf="previewTranslationEnabled">
                                <ng-container *ngIf="translationFormControl[lang]?.get('autoTranslate')?.value; else previewBtnSpacerTemp">
                                    <button
                                        *ngIf="
                                            lang == previewTranslationData?.previewLanguage &&
                                                (!!previewTranslationData?.translatedMessage?.length || !!previewTranslationData?.errorData);
                                            else clearPreviewBtn
                                        "
                                        (click)="setPreviewTranslationData()"
                                        mat-icon-button
                                    >
                                        <mat-icon class="material-symbols-outlined text-normal">preview_off</mat-icon>
                                    </button>
                                    <ng-template #clearPreviewBtn>
                                        <button (click)="fetchTranslationbyLanguage(lang)" mat-icon-button>
                                            <mat-icon class="material-symbols-outlined secondary-text">preview</mat-icon>
                                        </button>
                                    </ng-template>
                                </ng-container>
                                <ng-template #previewBtnSpacerTemp>
                                    <div style="width: 40px; height: 30px;"></div>
                                </ng-template>
                            </ng-container>

                            <ng-container *ngIf="!isAnalyzerLoading && getLanguageAnalyzerData(lang) as langAnalyzerData">
                                <div
                                    class="info-hover-wrapper ml-8"
                                    *ngIf="(langAnalyzerData.segmentCount ?? 0) > TRANSLATION_SEGMENT_THRESHOLD"
                                    [class.active]="activeSimplifyLanguage === lang"
                                    (click)="toggleSimplifyCard(lang)"
                                    (keydown.enter)="toggleSimplifyCard(lang)"
                                    (keydown.space)="toggleSimplifyCard(lang)"
                                    role="button"
                                    tabindex="0"
                                    [attr.aria-label]="'Click to simplify ' + lang + ' message'"
                                    [matTooltip]="'Click to simplify'"
                                    [matTooltipPosition]="'above'"
                                >
                                    <mat-icon class="info-icon">info</mat-icon>
                                    <div class="simplify-delivery-card" *ngIf="langAnalyzerData.simplifyForDelivery" (click)="$event.stopPropagation()">
                                        <p class="title">Ensure your message arrives</p>
                                        <p class="description">
                                            Removing special characters drops this from <strong>{{ langAnalyzerData.segmentCount }}</strong> to
                                            <strong>{{ langAnalyzerData.simplifyForDelivery?.simplifiedSegments }}</strong> segments, significantly reducing the risk of it being blocked.
                                        </p>
                                        <button class="simplify-btn" (click)="simplifyForDelivery(lang)">
                                            <mat-icon class="material-symbols-outlined">auto_fix_high</mat-icon> Simplify for Delivery
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <mat-slide-toggle
                                [id]="lang"
                                color="accent"
                                formControlName="autoTranslate"
                                [disabled]="disabled || isAnalyzerLoading"
                                (change)="handleToggleChange(lang, !translationFormControl[lang]?.get('autoTranslate')?.value)"
                                class="ml-16"
                            >
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div class="translation-preview-lang-content">
                        <ng-container
                            *ngIf="translationFormControl[lang]?.get('autoTranslate')?.value && previewTranslationData && (lang == previewTranslationData.previewLanguage); else contentInputTemp"
                        >
                            <div
                                *ngIf="previewTranslationData.translatedMessage?.length && !previewTranslationData.errorData"
                                class="mat-subtitle-2"
                            >
                                {{ previewTranslationData.translatedMessage }}
                            </div>
                            <ng-container *ngIf="previewTranslationData.errorData">
                                <ng-container *ngIf="(previewTranslationData.errorData.type == 'error'); else translateWarnTemp">
                                    <mat-card appearance="outlined" class="notify-warn-card error-warn mat-elevation-z0 mt-2">
                                        <div class="d-flex align-items-center">
                                            <mat-icon class="material-icon" [class.text-hint]="(previewTranslationData.errorData.type != 'error')">{{ (previewTranslationData.errorData.type == 'error') ? 'error' : 'data_alert'}}</mat-icon>
                                            <div class="mat-subtitle-2 m-0" [class.text-hint]="(previewTranslationData.errorData.type != 'error')">{{ previewTranslationData.errorData.message }}</div>
                                        </div>
                                    </mat-card>
                                    <a 
                                        class="mat-caption warn-text cursor-pointer ml-50" 
                                        style="text-decoration: underline;" 
                                        type="button" 
                                        (click)="fetchTranslationbyLanguage(lang)"
                                    >REFRESH TRANSLATION</a>
                                </ng-container>
                                <ng-template #translateWarnTemp>
                                    <div class="d-flex align-items-center ml-8 mb-24">
                                        <mat-icon class="material-symbols-outlined text-hint mr-8" style="font-weight: 800;">data_alert</mat-icon>
                                        <div class="mat-subtitle-2 m-0 text-hint" style="font-weight: 500;padding-top: 4px;">{{ previewTranslationData.errorData.message }}</div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <ng-template #contentInputTemp>
                            <mat-form-field class="example-full-width row-4 relative" appearance="outline" [style.fontSize.px]="14">
                                <mat-label>Enter your text here</mat-label>
                                <textarea matInput maxlength="750" placeholder="Enter your text here" formControlName="message"></textarea>
                                <div
                                    class="d-flex justify-content-end position-count mat-small grey"
                                    [ngClass]="{ 'warn-text': translationFormControl[lang]?.get('message')?.value?.length >= 750 }"
                                >
                                    {{ translationFormControl[lang]?.get('message')?.value?.length }}/750
                                </div>
                            </mat-form-field>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-template>
</div>
